'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var availabilityShape = _reactImmutableProptypes2.default.contains({
  circulationType: _react.PropTypes.string,
  localisedStatus: _react.PropTypes.string,
  heldCopies: _react.PropTypes.number,
  eresourceDescription: _react.PropTypes.string,
  singleBranch: _react.PropTypes.bool,
  metadataId: _react.PropTypes.string,
  availabilityLocationType: _react.PropTypes.string,
  status: _react.PropTypes.string,
  bibType: _react.PropTypes.string,
  totalCopies: _react.PropTypes.number,
  libraryUseOnly: _react.PropTypes.bool,
  eresourceUrl: _react.PropTypes.string,
  availableCopies: _react.PropTypes.number
});

exports.default = availabilityShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/availabilityShape.js
// module id = 365
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16